import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'

export const container = css`
  background-color: #1a1a1a;
  min-height: 100vh;
  color: ${colors.white100};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  overflow-y: auto;
`

export const header = css`
  display: flex;
  align-items: center;
  padding: ${spacing(4)} ${spacing(2)};
  background-color: #1a1a1a;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const backArrow = css`
   background: transparent;
   border: none;
   padding: 0;
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${spacing(2)};
  top: 50%;
  transform: translateY(-50%);
`

export const headerTitle = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 600;
  flex: 1;
  text-align: center;
`

export const loadingContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(4)};
`

export const loadingText = css`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
`

export const errorContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(4)};
`

export const errorText = css`
  color: #ff6b6b;
  margin: 0;
`

export const calendarContainer = css`
  padding: ${spacing(3)} ${spacing(2)};
`

export const calendarHeader = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${spacing(3)};
`

export const monthYear = css`
  color: ${colors.white100};
  margin: 0;
`

export const navigation = css`
  display: flex;
  gap: ${spacing(2)};
`

export const navArrow = css`
  background: transparent;
  border: none;
  padding: 0;
  color: ${colors.white100};
  font-size: 18px;
  cursor: pointer;
  user-select: none;
  
  &:hover {
    opacity: 0.7;
  }
`

export const daysOfWeek = css`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: ${spacing(1)};
  margin-bottom: ${spacing(2)};
`

export const dayOfWeek = css`
  text-align: center;
  padding: ${spacing(1)};
`

export const dayOfWeekText = css`
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  margin: 0;
`

export const calendarGrid = css`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: ${spacing(1)};
  margin-bottom: ${spacing(3)};
`

export const dayCell = css`
  aspect-ratio: 1;
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: transparent;
  border: none;
  border-radius: ${spacing(1)};
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-height: 48px;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:disabled {
    cursor: default;
  }

  &:disabled:hover {
    background-color: transparent;
  }
`

export const dayActive = css`
  cursor: pointer;
`

export const daySelected = css`
  background-color: #6FCF97 !important;
  
  &:hover {
    background-color: #6FCF97 !important;
  }
`

export const dayText = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 500;
  z-index: 1;
`

export const eventDot = css`
  position: absolute;
  bottom: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
`

export const gamesSection = css`
  padding: ${spacing(2)} ${spacing(2)} ${spacing(4)};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`

export const gamesTitleContainer = css`
  margin-bottom: ${spacing(3)};
  display: flex;
  flex-direction: column;
`

export const gamesTitle = css`
  color: ${colors.white100};
  margin: 0;
`

export const gamesDate = css`
  color: rgba(255, 255, 255, 0.7);
  margin: ${spacing(0.5)} 0 0 0;
`

export const noEventsText = {
  color: '#888888',
  textAlign: 'center',
  marginTop: '40px',
}

export const gamesContainer = css`
	display: flex;
	flex-direction: column;
	gap: ${spacing(2)};
` 
